<template>
  <b-modal
    id="modal-multi-3"
    size="sm"
    title="Confirmación"
    ok-only
    ok-title="Accept"
    v-model="$store.state.someVariables.showConfirmacionLog"
  >
    <b-card-text class="my-1">
      ¿ Deseas realmente eliminar el item ?
    </b-card-text>
    <template #modal-footer>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        class="float-right mr-1"
        @click="close"
      >
        Cancelar
      </b-button>
      <b-button
        v-if="!showLoading"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="float-right"
        @click="ocultarEliminar"
      >
        Aceptar
      </b-button>
      <div v-if="showLoading" class="text-center mt-1">
        <b-spinner variant="primary" label="Text Centered" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BCardText,
  BButton,
  BSpinner,
  // xxx,
  // xxxx,
  // sss,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { ref } from '@vue/composition-api'
import apiCall from '../../utils/apiCall'
import {
  URL,
  //   USER,
  //   ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    BCardText,
    BButton,
    BSpinner,
  },
  directives: {
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    action: String,
    dataLog: Object,
  },
  setup(props, { emit }) {
    const showLoading = ref(false)
    const { postApi } = apiCall()
    function close() {
      store.commit('someVariables/UPDATE_SHOW_CONFIRMA_PARTIDO_REVISADO', false)
    }
    async function ocultarLog(item) {
      showLoading.value = true
      const path = 'ApiMovimientos/ocultaMovimiento'
      const data = {
        idMovimiento: item.id_movimiento,
      }
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        emit('oculto')
      }
      showLoading.value = false
    }
    async function deleteLog(item) {
      showLoading.value = true
      const path = 'ApiMovimientos/deleteMovimiento'
      const data = {
        idMovimiento: item.id_movimiento,
      }
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        emit('oculto')
      }
      showLoading.value = false
    }

    function ocultarEliminar() {
      if (props.action === 'ocultar') {
        ocultarLog(props.dataLog)
      } else {
        deleteLog(props.dataLog)
      }
    }

    return {
      close,
      showLoading,
      ocultarEliminar,
      deleteLog,
    }
  },
}
</script>
